import { graphql, useFragment } from "react-relay";

import { TodoToolbarButtonTeams_teams$key } from "./__generated__/TodoToolbarButtonTeams_teams.graphql";

import { TodoToolbarButtonTeamsDetail_teams$key } from "./__generated__/TodoToolbarButtonTeamsDetail_teams.graphql";

import {
  AHTeamIconCircleRelay,
  DialogButton,
  Overlap,
  useCircleSize,
} from "arkh";
import { TeamNamesLabel } from "../../DialogButtonTeams";
const MAX_SHOWING_INDICATORS = 3;

export function TodoToolbarButtonTeams(props: {
  teams: TodoToolbarButtonTeams_teams$key;
  onPress: () => void;
  isLocked: boolean;
}) {
  const teams = useFragment(
    graphql`
      fragment TodoToolbarButtonTeams_teams on Team @relay(plural: true) {
        id
        name
        ...TodoToolbarButtonTeamsDetail_teams
      }
    `,
    props.teams
  );

  return (
    <DialogButton
      mode={props.isLocked ? "locked-active" : "active"}
      onPress={props.onPress}
      indicatorComponent={
        teams.length > 0 ? (
          <TodoToolbarButtonTeamsDetail teams={teams} />
        ) : undefined
      }
      indicatorIcon={teams.length === 0 ? "team-home" : undefined}
    >
      <TeamNamesLabel
        names={teams.map((e) => e.name)}
        maxShowingIndicators={MAX_SHOWING_INDICATORS}
      />
    </DialogButton>
  );
}

function TodoToolbarButtonTeamsDetail(props: {
  teams: TodoToolbarButtonTeamsDetail_teams$key;
}) {
  const teams = useFragment(
    graphql`
      fragment TodoToolbarButtonTeamsDetail_teams on Team @relay(plural: true) {
        id
        ...AHTeamIconCircle
      }
    `,
    props.teams
  );
  const size = useCircleSize("smallMedium");

  return (
    <Overlap
      data={teams}
      viewWidth={size}
      maxNumberOfItems={MAX_SHOWING_INDICATORS}
      render={(t) => <AHTeamIconCircleRelay team={t} size="small" />}
    />
  );
}
